import { config } from '../config';
import axios from 'axios';

// import axios from 'axios';

export const retailers = {
  /**
   * getRetailers - get list of agriculture retailers based on latitude and longitude
   * @param  {float} latitude
   * @param  {float} longitude
   * @return {[{Retailer}]} array of weekly agriculture retailers
   */
  getRetailers(feed, latitude, longitude, address) {
    feed = feed || 'agriculture';
    // Set the country, based upon the country
    let country = 'US';
    
    if(address.split(/[, ]+/).pop() == 'CAN' || address.split(/[, ]+/).pop() == 'CA'){
      country = 'CA';
    }
    
    if(address.split(/[, ]+/).pop() == 'USA' || address.split(/[, ]+/).pop() == 'US'){
      country = 'US';
    }
    
    const endpoint = config.endpoints[feed].replace('{country}', country).replace('{latitude}', latitude).replace('{longitude}', longitude);

    let data = axios.get( endpoint, {
      headers : {
        'X-API-Key' : 'TOPTECH:3a57df5e1568',
        'Accept-language' : 'en',
        'Accept' : 'application/json',
        'mode' : 'no-cors'
      }
    });

    return data;
  }
}